export function isPersistentValue(value, isPersistent) {
  return isPersistent || value === null
}
